import { render } from "./RiversWin.vue?vue&type=template&id=334eb389"
import script from "./RiversWin.vue?vue&type=script&lang=js"
export * from "./RiversWin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__